<template>
  <div class="banner" :style="{ height: bannerHeight + 'px' }">
    <div class="mm"></div>
    <div class="banner-img">
      <img :src="img" />
    </div>
    <div class="banner-title">
      <p>{{title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: require("../assets/img/bgtop.jpg")
    },
    height: {
      type: Number,
      default: 200  // 新增高度属性，默认200px
    }
  },
  computed: {
    bannerHeight() {
      return this.height;
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 200px; // 默认高度设为200px，会被props中的高度覆盖
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(10px);

    background-image: url(../assets/img/bgtop.jpg);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 30px; // 减小字体大小以适应新高度
    font-weight: 400;
    line-height: 200px; // 调整行高以适应新高度
    text-align: center;
    width: 100%;
  }
}
</style>